const fieldName = {
  NAME: 'name',
  PROGRAMS: 'programs',
  TYPE: 'type',
  DIFFICULTY: 'difficulty',
  LOCATION: 'location',
  EQUIPMENT: 'equipment',
};

const programAttributes = {
  ID: 'id',
  LABEL: 'label',
  PROGRAM: 'program',
  EQUIPMENT: 'equipment',
  REPEAT_COUNT: 'repeatCount',
};

export {
  fieldName,
  programAttributes,
};
